import * as React from "react";

import { Typography, withStyles, WithStyles } from "@material-ui/core";
import styles from "../../styles/generic/contact-info";
import { CustomStyles } from "../../types";
import strings from "../../localization/strings";

/**
 * Interface describing optional props
 */
export interface OptionalProps {
}

/**
 * Interface describing component properties
 */
export interface Props extends WithStyles<typeof styles> {
  customStyles?: CustomStyles;
}

/**
 * Functional component for contact info
 * 
 * @param props component props
 */
const ContactInfo: React.FC<Props & OptionalProps> = ({
  classes,
  customStyles
}) => {

  /**
   * Component render
   */
  return (
    <div
      className={ classes.container }
      style={ customStyles?.container }
    >
      <Typography
        className={ classes.name }
      >
        { strings.client.addressName }
      </Typography>
      <div className={ classes.contactInfo }>
        <p>
          Kampusranta 9 C
          <span className="separator-horizontal" aria-hidden="true">___</span>
          Frami
          <span className="separator-horizontal" aria-hidden="true">___</span>
          4. kerros
          <span className="separator-horizontal" aria-hidden="true">___</span>
          60101 Seinäjoki
        </p>
        <p>
          p. 040 665 1960
          <span className="separator-horizontal" aria-hidden="true">___</span>
          kirjaamo@etela-pohjanmaa.fi
        </p>
      </div>
    </div>
  );
}

const Styled = withStyles(styles)(ContactInfo);

export default Styled;